import PropTypes from 'prop-types';
import React, {Component} from 'react';
import { connect } from '~/redux/connect';
import CenterWrapper from "~/components/CenterWrapper/CenterWrapper";
import {Area, Box, H1} from "~/native-ui";

class NotFoundPage extends Component {
    static propTypes = {};

    render() {
        const { trans } = this.props;

        return (
            <CenterWrapper>
                <Area>
                    <H1>{trans('notFoundPage.title')}</H1>
                    <Box>{trans('notFoundPage.message')}</Box>
                </Area>
            </CenterWrapper>
        );
    }
}

const RXNotFoundPage = connect()(NotFoundPage);

export default RXNotFoundPage;